

export const onAddonandVideoTaskLabelCreate = (values) => {

    const errors = {}
     if (required(values.task_type)) {
        errors.task_type = 'Task Type is required'
    } 
    if (required(values.type)) {
        errors.type = 'Type required'
    }
   if (values.type === 'Option' && required(values.label_id)) {
    errors.label_id = 'Label Id is required when type is Option';
}
    return errors;
   
};

export const onAddonandVideoTaskLabelEdit = (values) => {

    const errors = {}
  
      if (required(values.task_type)) {
        errors.task_type = 'Task Type is required'
    } 
    if (required(values.type)) {
        errors.type = 'Type required'
    }
   if (values.type === 'Option' && required(values.label_id)) {
    errors.label_id = 'Label Id is required when type is Option';
}
    return errors;
   
};

















const isEmpty = (value: any) =>{
    return (typeof value === 'undefined' || value === null || value === '')
}

export const required = (value) =>{
    return isEmpty(value)
}


